import React from 'react';
import { useRouter } from 'next/router';

import Beacon from '@/assets/scripts/Beacon';

import WithAccountLayout from '@/layouts/withAccount.layout';
import WithLocationLayout from '@/layouts/withLocation.layout';
import WithModalLayout from '@/layouts/withModal.layout';
import WithToastLayout from '@/layouts/withToast.layout';
import WithViewportLayout from '@/layouts/withViewport.layout';
import WithSolutionLayout from '@/layouts/withSolution.layout';

import { themeHelpers } from '@/utils/helpers';

const withStandardLayout = ({ host, theme, children }) => {
  const router = useRouter();
  const resolvedTheme = theme ?? themeHelpers.getTheme(router);

  return (
    <div className="pageRoot" data-theme={resolvedTheme} data-solution={host}>
      <WithSolutionLayout host={host}>
        <WithViewportLayout>
          <WithToastLayout>
            <WithLocationLayout>
              <WithAccountLayout>
                <WithModalLayout>
                  <Beacon />
                  {children}
                </WithModalLayout>
              </WithAccountLayout>
            </WithLocationLayout>
          </WithToastLayout>
        </WithViewportLayout>
      </WithSolutionLayout>
    </div>
  );
};

export default withStandardLayout;
